export const defaultJITConfig = { message: '', showMessage: false };
